import Ajv, { JSONSchemaType, Schema } from 'ajv'
import addAjvFormats from 'ajv-formats'
import addAjvErrors from 'ajv-errors'

export {
  default as Ajv,
  type SchemaObject,
  type JSONSchemaType,
  type ValidateFunction,
} from 'ajv'
export { default as addAjvFormats } from 'ajv-formats'

export const defaultAjv = new Ajv({
  strict: false,
  allErrors: true,
  $data: true,
  useDefaults: true,
})
addAjvFormats(defaultAjv)
addAjvErrors(defaultAjv)
defaultAjv.addFormat('uint64', {
  type: 'number',
  validate: function validateUInt64(value: number): boolean {
    // JSON and javascript max Int is 2**53, so any int that passes isInteger is valid for Int64
    return Number.isInteger(value) && value >= 0
  },
})

export function compileJsonSchema(
  schema: Schema | JSONSchemaType<unknown>
) {
  return defaultAjv.compile(schema)
}
